import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import auth from './auth';
import bill from './bill';

const reducer = history =>
  combineReducers({
    router: connectRouter(history),
    auth,
    bill,
  });

export default reducer;
